import React, { useState, useEffect } from "react";
import { ChevronRight } from "lucide-react";
import logo from "./image/logo.png";
import "./header.css";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Detect window size for mobile toggle
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 900);
    handleResize(); // run once on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const closeAndGo = () => setOpen(false);

  return (
    <header className="header">
      <div className="header__row">
        <div className="logo">
          <img
            src={logo}
            alt="Red Pearl Contracting Ltd logo"
            className="logo__img"
          />
          <div className="logo__text">
            <div className="logo__title">Red Pearl</div>
            <div className="logo__sub">Contracting Ltd</div>
          </div>
        </div>
      </div>

      <div className="accent">
        <div className="accent__black"></div>
        <div className="accent__red">
          <div className="accent__diag"></div>
        </div>
      </div>

      <div className="navbar">
        <div className="navbar__row rp-nav">
          {/* Desktop Links */}
          {!isMobile && (
            <nav className="navbar__links">
              <a href="/#home" className="navbar__link navbar__link--active">HOME</a>
              <a href="/#services" className="navbar__link">SERVICES</a>
              <a href="/careers" className="navbar__link">CAREERS</a>
              <a href="/#about" className="navbar__link">ABOUT</a>
            </nav>
          )}

          {/* Menu Button (only shows on mobile) */}
          {isMobile && (
            <button
              className="rp-burger"
              onClick={() => setOpen((v) => !v)}
              aria-haspopup="true"
              aria-expanded={open}
            >
              {open ? "Close" : "Menu"}
            </button>
          )}

          <a href="/#contact" className="cta">
            CONTACT US TODAY <ChevronRight size={16} />
          </a>

          {/* Dropdown Menu — only on mobile */}
          {isMobile && open && (
            <div className="rp-dropdown" role="menu">
              <a href="/#home" className="rp-item" onClick={closeAndGo}>HOME</a>
              <a href="/#services" className="rp-item" onClick={closeAndGo}>SERVICES</a>
              <a href="/careers" className="rp-item" onClick={closeAndGo}>CAREERS</a>
              <a href="/#about" className="rp-item" onClick={closeAndGo}>ABOUT</a>
              <div className="rp-divider" />
              <a href="/#contact" className="rp-item rp-item-cta" onClick={closeAndGo}>
                CONTACT US TODAY
              </a>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
